// import classNames from "classnames";
// import Select from "react-tailwindcss-select";
// import useSWRGlobalState from "../../hooks/useSWRGlobalState";

// function Selector({
//   name,
//   label = "",
//   value = null,
//   options = [],
//   placeholder = "Select your option",
//   helpText,
//   error,
//   onChange,
//   isSearchable,
//   isClearable,
//   disabled,
//   isSelected,
//   required,
//   selectedValues,
// }) {
//   const [isMenuOpen, setIsMenuOpen] = useSWRGlobalState("menuOpenState", false);
//   const valueIsObject = value && typeof value === "object" && "label" in value;
//   const isValuePresent = valueIsObject ? value?.label : value?.length;

//   const handleChange = (selected) => {
//     if (onChange) {
//       onChange(name, selected);
//     }
//   };

//   return (
//     <div
//       className={classNames(
//         "w-full space-y-0.5",
//         isMenuOpen && "selector_relative_position"
//       )}
//       onClick={() => {
//         setIsMenuOpen(false);
//       }}
//     >
//       {label && (
//         <>
//           <label
//             className="text-gray-700 mb-2 font-regular flex items-center text-sm"
//             htmlFor={name}
//           >
//             {label}
//             {required && <span className="text-red-500 ml-1">*</span>}
//           </label>
//         </>
//       )}
//       <Select
//         name={name}
//         value={value}
//         onChange={handleChange}
//         isDisabled={disabled}
//         isSearchable={isSearchable}
//         classNames={{
//           menuButton: (arg) =>
//             classNames(
//               `flex overflow-hidden pl-3.5 h-9 items-center justify-between text-sm font-normal bg-white focus:text-black focus:ring-2 focus:ring-primary border border-solid border-gray-300 rounded-md`,
//               !arg?.isDisabled && label && "text-gray-400",

//               isValuePresent ? "text-black" : "custom_text_gray",
//               !arg?.isDisabled &&
//                 `focus:bg-white focus:border-primary focus:outline-none`,
//               arg?.isDisabled && "important_disable_bg"
//             ),
//           menu: `absolute z-10 w-full bg-white text-gray-700 shadow-lg border rounded py-1 mt-1.5 text-sm`,
//           listItem: (arg) => {
//             const isSelected = arg?.isSelected; // Check if `arg` contains isSelected

//             return classNames(
//               "block transition duration-200 px-2 py-2 cursor-pointer select-none truncate rounded",
//               isSelected
//                 ? "text-darkBg bg-gray-300"
//                 : "text-gray-500 hover:bg-gray-100"
//             );
//           },
//         }}
//         options={options}
//         formatOptionLabel={(option) => {
//           if (selectedValues) {
//             const isSelectedOption =
//               !Array.isArray(option) &&
//               selectedValues.some((item) => item.value === option.value);
//             if (isSelectedOption) {
//               return (
//                 <div
//                   className={classNames(
//                     "block transition duration-200 px-2 py-2 select-none truncate rounded cursor-not-allowed pointer-events-none text-gray-300" // Disable interactions
//                   )}
//                 >
//                   {option.label}
//                 </div>
//               );
//             }
//           }

//           return (
//             <div
//               className={classNames(
//                 "block transition duration-200 px-2 py-2 cursor-pointer select-none truncate rounded",
//                 isSelected
//                   ? "text-darkBg bg-gray-300"
//                   : "text-gray-500 hover:bg-gray-100"
//               )}
//             >
//               {option.label}
//             </div>
//           );
//         }}
//         placeholder={placeholder}
//         isClearable={isClearable}
//       />
//       {error && <p className="text-red-500 text-sm mt-1">{error}</p>}

//       {helpText && (
//         <p className="mt-1 text-xs text-black md:text-sm">{helpText}</p>
//       )}
//     </div>
//   );
// }

// export default Selector;
import Select from "react-select";
import classNames from "classnames";
import useSWRGlobalState from "../../hooks/useSWRGlobalState";
import CreatableSelect from "react-select/creatable";

function Selector({
  name,
  label = "",
  value = null,
  options = [],
  placeholder = "Select your option",
  helpText,
  error,
  onChange,
  isSearchable = false,
  isClearable = false,
  disabled = false,
  required = false,
  selectedValues = [],
  multiple,
  creatable,
}) {
  const [isMenuOpen, setIsMenuOpen] = useSWRGlobalState("menuOpenState", false);
  const SelectComponent = creatable ? CreatableSelect : Select;

  const handleChange = (selected) => {
    if (onChange) {
      onChange(name, selected);
    }
  };

  return (
    <div
      className={classNames(
        "w-full space-y-0.5",
        isMenuOpen && "selector_relative_position"
      )}
      onClick={() => setIsMenuOpen(false)}
    >
      {label && (
        <label
          className="text-gray-700 mb-2 font-regular flex items-center text-sm capitalize"
          htmlFor={name}
        >
          {label}
          {required && <span className="text-red-500 ml-1">*</span>}
        </label>
      )}

      <SelectComponent
        name={name}
        value={
          multiple
            ? value // Multiple values
            : options.find((item) => item.value === value?.toString()) // Single value
        }
        onChange={handleChange}
        isDisabled={disabled}
        isSearchable={isSearchable}
        isClearable={isClearable}
        options={options}
        isMulti={multiple}
        placeholder={placeholder}
        classNamePrefix="react-select"
        styles={{
          control: (provided, state) => ({
            ...provided,
            padding: "2px 8px",
            minHeight: "36px",
            fontSize: "14px",
            borderRadius: "6px",
            border: state.isFocused ? "2px solid #2a4258" : "1px solid #d1d5db",
            boxShadow: state.isFocused
              ? "0 0 0 2px rgba(0, 123, 255, 0.2)"
              : "",
            backgroundColor: disabled ? "#f3f4f6" : "white",
            color: disabled ? "#9ca3af" : "#000",
            cursor: disabled ? "not-allowed" : "pointer",
          }),
          menu: (provided) => ({
            ...provided,
            zIndex: 10,
            backgroundColor: "white",
            borderRadius: "6px",
            border: "1px solid #d1d5db",
            boxShadow: "0px 4px 6px rgba(0,0,0,0.1)",
          }),
          option: (provided, state) => ({
            ...provided,
            padding: "10px 12px",
            fontSize: "14px",
            cursor: "pointer",
            backgroundColor: state.isSelected
              ? "#e5e7eb"
              : state.isFocused
              ? "#f3f4f6"
              : "white",
            color: state.isSelected ? "#111827" : "#374151",
            transition: "background-color 0.2s ease-in-out",
          }),
          singleValue: (provided) => ({
            ...provided,
            color: "#000",
          }),
        }}
      />

      {error && <p className="text-red-500 text-sm mt-1">{error}</p>}

      {helpText && (
        <p className="mt-1 text-xs text-black md:text-sm">{helpText}</p>
      )}
    </div>
  );
}

export default Selector;
